<template>
  <div class="footer-bg">
    <div style="margin-left: calc(50% - 700px); width: 1400px; position: relative">
      <div
          v-html="info.content"
          class="footer-content">
      </div>
      <div
          style="color: white;
         display: inline-block;
         vertical-align: top;
         position: absolute;
         text-align: center;
         top:50px; right: 0">
        <el-image style="height: 100px" :src="pic"></el-image>
        <div style="font-size: 14px; margin-top: 5px">公众号</div>
      </div>
    </div>

    <div class="f-copyright">
      福建省质量检验协会 版权所有 ©{{ new Date().getFullYear() }}   备案号：闽ICP备2021003345号-1
    </div>
  </div>
</template>

<script>
import {getNewsList} from "@/api/news";

export default {
  name: "footer",
  data() {
    return {
      info: {
        content: ''
      },
      pic: ''
    }
  },
  mounted() {
    getNewsList({
      type: '网页结尾',
      pagesize: 1,
      pagenow: 1
    }).then(res => {
      if (res && res.length > 0) {
        this.info = Object.assign({}, res[0])
        if (this.info.file_paths) {
         this.pic =  this.info.file_paths.split(',')[0]
        }
      }
    })
  }
}
</script>

<style scoped>
.footer-bg {
  background: #033777;
  min-height: 240px;
  position: relative;
  min-width: fit-content;

}

.f-copyright {
  text-align: center;
  position: absolute;
  color: white;
  font-size: 12px;
  width: 100%;
  bottom: 10px;
}

.footer-content {
  color: white;
  min-height: 180px;
  width: 600px;
  padding: 30px 0 30px 0;
  line-height: 1.8;
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
}
</style>
